import Isotope from 'isotope-layout';
import Abstract from './class.Abstract';
import Filter from './class.Filter';

class CategoryFilter extends Filter {
  constructor() {
    super();

    if (!document.querySelectorAll('.products__tab-btn').length) return;

    super.currentCategoryFilter = CategoryFilter.getURLFilterParameter();
    this.productsTabNavs = document.querySelectorAll('.products__tab-btn');
    this.productsTabNavsMobileWrapper = document.querySelector('.products__tabs-nav--mobile');
    this.mobileTabsContainer = document.querySelector('.products__tabs-nav--mobile');
    this.isotopeInstance = null;

    this.init();
  }

  init() {
    this._initIsotope();
    this._initEvents();
  }

  _initIsotope() {
    this.isotopeInstance = new Isotope('.products__list', {
      itemSelector: '.product-item',
      percentPosition: true,
      layoutMode: 'fitRows',
    });
  }

  static getURLFilterParameter() {
    const url = new URL(location.href);
    return new URLSearchParams(url.search).get('filter');
  }

  _initEvents() {
    if (super.currentCategoryFilter) {
      this.changeActiveTab();
      this.filter();
    }

    this.productsTabNavs.forEach((nav) => {
      nav.addEventListener('click', () => {
        const filter = nav.dataset.name.trim();

        this.updateFilterParameter(filter);
        this.changeActiveTab();
        this.filter();
      });
    });

    if (window.matchMedia('(max-width: 1280px)').matches) {
      document.addEventListener('click', (e) => {
        const node = e.target;

        if (node.classList.contains('products__tab-btn--active-tab')) {
          this.mobileTabsContainer.classList.toggle('products__tabs-nav--mobile_hidden');
        }
      });
    }
  }

  changeActiveTab() {
    Abstract.findClassNameAndRemove('products__tab-btn--active-tab');
    Abstract.findClassNameAndRemove('products__tab-btn--active-tab', this.productsTabNavsMobileWrapper);

    const buttons = document.querySelectorAll(`.products__tab-btn[data-name="${super.currentCategoryFilter}"`);

    buttons.forEach((button) => {
      button.classList.add('products__tab-btn--active-tab');
    });
  }

  updateFilterParameter(value) {
    super.currentCategoryFilter = (value === 'all') ? '*' : value;

    const url = new URL(location.href);
    url.searchParams.set('filter', value);

    history.replaceState(null, null, url.href);
  }

  filter() {
    const filterRule = super.generateFilterSelectorString();

    this.isotopeInstance.arrange({
      filter: filterRule,
    });
  }
}

export default CategoryFilter;
